import styled from 'styled-components'

const StatLabel = styled.h3`
    color: #fafafa;
    font-weight: 700;
    font-size: 0.5rem;
    letter-spacing: 2px;
    margin: 0;
`

export default StatLabel